import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { authApi } from '../../services/api';
import './Auth.css';

export const ResetPasswordPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.search).get('token') || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError('Geçersiz veya eksik şifre sıfırlama bağlantısı.');
      return;
    }

    if (newPassword.length < 8) {
      setError('Şifreniz en az 8 karakter uzunluğunda olmalıdır.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Girdiğiniz şifreler birbiriyle eşleşmiyor.');
      return;
    }

    setLoading(true);

    try {
      const res = await authApi.resetPassword({ token, newPassword });
      if (res.success) {
        setSuccess(true);
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Şifre güncellenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-logo-badge">⚠️</div>
            <h2 className="auth-title">Geçersiz Bağlantı</h2>
            <p className="auth-subtitle">
              Şifre sıfırlama belirteci bulunamadı. Lütfen e-posta adresinize gelen bağlantıya tıkladığınızdan emin olun.
            </p>
          </div>
          <div className="auth-footer-nav">
            <Link to="/forgot-password" style={{ color: '#2563eb', fontWeight: 700 }}>
              Yeni Bir Sıfırlama Bağlantısı İste
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo-badge">🔐</div>
          <h2 className="auth-title">Yeni Şifre Belirle</h2>
          <p className="auth-subtitle">
            Hesabınız için güçlü ve güvenli yeni bir şifre oluşturun.
          </p>
        </div>

        {error && <div className="auth-alert error">⚠️ {error}</div>}

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div className="auth-alert success">
              ✅ Şifreniz başarıyla yenilendi ve hesabınızın kilidi kaldırıldı!
            </div>
            <p style={{ color: '#64748b', fontSize: '0.9rem', margin: '20px 0' }}>
              Artık yeni şifrenizle sisteminize güvenle giriş yapabilirsiniz.
            </p>
            <button
              type="button"
              className="auth-submit-btn"
              onClick={() => navigate('/login')}
            >
              Giriş Yap 🚀
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label>Yeni Şifre (En az 8 karakter)</label>
              <div className="auth-password-wrapper">
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  className="auth-input"
                  minLength={8}
                  autoFocus
                />
                <button
                  type="button"
                  className="auth-password-toggle"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  title={showNewPassword ? 'Şifreyi Gizle' : 'Şifreyi Göster'}
                  aria-label="Şifreyi Göster veya Gizle"
                >
                  {showNewPassword ? '👁️' : '🙈'}
                </button>
              </div>
            </div>

            <div className="form-group">
              <label>Yeni Şifre Tekrar</label>
              <div className="auth-password-wrapper">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  className="auth-input"
                  minLength={8}
                />
                <button
                  type="button"
                  className="auth-password-toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  title={showConfirmPassword ? 'Şifreyi Gizle' : 'Şifreyi Göster'}
                  aria-label="Şifreyi Göster veya Gizle"
                >
                  {showConfirmPassword ? '👁️' : '🙈'}
                </button>
              </div>
            </div>

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading ? 'Güncelleniyor...' : 'Şifremi Kaydet ve Girişe Dön 💾'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
